import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-splitter-container", { 'is-dragging': _ctx.isDragging }]),
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args)))
  }, [...(_cache[1] || (_cache[1] = [
    _createStaticVNode("<div class=\"splitter-track\" data-v-303392ed><div class=\"splitter-bar\" data-v-303392ed><div class=\"splitter-handle-pill\" data-v-303392ed><span class=\"grip-dot\" data-v-303392ed></span><span class=\"grip-dot\" data-v-303392ed></span><span class=\"grip-dot\" data-v-303392ed></span></div></div></div>", 1)
  ]))], 34))
}